import React from "react";
import { Link } from "react-router-dom";

const isExternalLink = (link) => link.startsWith("http");

const renderNavBarItems = (style, items, onItemClick) => {
  return (
    <ul className={style.ulClass}>
      {items.map((item) => {
        const itemContent = (
          <>
            {item.icon}
            <span className={item.icon ? "ml-2" : ""}>{item.title}</span>
          </>
        );

        return (
          <li className={style.liClass} key={item.title}>
            {isExternalLink(item.link) ? (
              <a
                className={`${style.aClass} flex items-center`}
                href={item.link}
                onClick={onItemClick}
                target="_blank"
                rel="noreferrer"
              >
                {itemContent}
              </a>
            ) : (
              <Link
                className={`${style.aClass} flex items-center`}
                onClick={onItemClick}
                to={item.link}
              >
                {itemContent}
              </Link>
            )}
          </li>
        );
      })}
    </ul>
  );
};

function NavigationMenu({ navBarCss = {}, navBarItems = [], onItemClick }) {
  return <div>{renderNavBarItems(navBarCss, navBarItems, onItemClick)}</div>;
}

export default NavigationMenu;
